// @flow

import React from 'react';
import SearchResultsContainer from './searchResults.container';

type ACFProps = {|
  items_found_text: string,
  items_not_found_text: string,
|};

type Props = ACFProps;

const ACFSearchResults = ({
  items_found_text,
  items_not_found_text,
}: Props) => (
  <SearchResultsContainer
    noResultsHeader={items_not_found_text}
    resultsHeader={items_found_text}
  />
);

export default ACFSearchResults;
